// autocomplete hooks
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options)  {
      // console.log('beforeAutocompleteOptions', options);
    options.placeholder = "Search our store";
    // SC 4.1.2 — the widget labels the input via aria-labelledby pointing at a
    // <label> whose aria-label is submitButtonTitle, so the field's accessible
    // name was "Submit". Naming the button names the input.
    options.translations = Object.assign({}, options.translations, {
      submitButtonTitle: "Search",
    });
    return options;
  });
  });
  document.addEventListener("algolia.hooks.initialize", () => {
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      (
        _defaultTemplate,
        templateOptions,
        distinct,
        itemLink,
        trackSearchAttribution
      ) => {
        const { html, item, components } = templateOptions;
        // Fallback to default title if the metafield is missing   
          const displayTitle =
          item.meta?.global?.title && item.meta.global.title.trim() !== ''
            ? item.meta.global.title
            : components.Highlight({ hit: item, attribute: 'title' });     
  return html`
          <a
            href="${itemLink}"
            class="aa-ItemLink aa-ProductItem"
            onClick="${() => trackSearchAttribution(item)}"
          >
            <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                <img
                  src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                  srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                  sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                  alt="${displayTitle}"
                />
        </div>
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">
                    ${displayTitle}
                    <span class="algolia-variant">
                      ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                    </span>
                  </div>
                </div>
                <!-- Add any additional fields, price, etc., as desired -->
                <div class="aa-ItemContentBrand">
                  ${item.meta?.global?.contributor ? item.meta?.global?.contributor : item.meta?.global?.publisher}
                </div>
              </div>
            </div>
          </a>
      `;
    }
  );
});

  document.addEventListener("algolia.hooks.initialize", () => {
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteNoResultsTemplate",
      (_defaultTemplate, templateOptions) => {
        const { html, state } = templateOptions;
        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <p class="aa-NoResultsHeader">
              ${algoliaShopify.translation_helpers.no_result_for(state.query)}
            </p>
            <a
              class="link"
              href="/collections/all-products"
            >
              Browse all products
            </a>
          </div>
        `;
      }
    );
  });

  document.addEventListener("algolia.hooks.initialize", () => {
    function stripHtml(html) {
      var tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }
  
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteCollectionsTemplate",
      (_defaultTemplate, templateOptions, itemLink) => {
        const { html, item, components } = templateOptions;
  
        let titleContent;
        if (
          item._highlightResult &&
          item._highlightResult.title &&
          item._highlightResult.title.value &&
          /<mark>/.test(item._highlightResult.title.value)
        ) {
          titleContent = components.Highlight({ hit: item, attribute: "title" });
        } else {
          titleContent = stripHtml(item.title);
        }
  
        return html`
          <a href="${itemLink}" class="aa-ItemLink custom-collection">
            <div class="aa-ItemWrapper">
              <div class="aa-ItemContent">
                <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                  ${item.image && item.image.src
                    ? html`<img src="${item.image.src}" alt="" style="height: 48px;" />`
                    : ""}
                </div>
                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitle">
                    ${titleContent}
                  </div>
                </div>
              </div>
            </div>
          </a>
        `;
      }
    );
  });

// InstantSearch hooks - PLP and Search Results
/** Uses Algolia’s displayPrice with a cloned hit so amounts use shop currency/format. */
function displayPriceForAmount(hit, amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) {
    return '';
  }
  return algoliaShopify.helpers.displayPrice(
    Object.assign({}, hit, { price: n })
  );
}

/**
 * PLP price markup: single/range, sale + strikethrough + dollar savings.
 * Port of legacy formattedPriceWithComparison (formatPrice → displayPriceForAmount).
 */
function renderHitPriceDisplay(hit, html, onSale) {
  const price = Number(hit.price) || 0;
  const compareAt = Number(hit.compare_at_price) || 0;
  const minV = Number(hit.variants_min_price);
  const maxV = Number(hit.variants_max_price);
  const min = Number.isFinite(minV) ? minV : price;
  const max = Number.isFinite(maxV) ? maxV : price;
  const hasRange = min !== max;
  const comparing = Boolean(compareAt) && compareAt > min;
  const showSale = comparing || onSale === true;

  if (showSale) {
    if (hasRange) {
      return html`<b class="ais-hit--price-sale">${displayPriceForAmount(hit, min)} - ${displayPriceForAmount(hit, max)}</b>`;
    }
    const saleAmount = compareAt - price;
    return html`
      <b class="ais-hit--price-sale">${displayPriceForAmount(hit, price)}</b>
      <span class="ais-hit--price-striked">${displayPriceForAmount(hit, compareAt)}</span>
      ${saleAmount > 0 &&
        html`<span class="ais-hit--price-savings">Save ${displayPriceForAmount(hit, saleAmount)}</span>`}
    `;
  }

  if (hasRange) {
    return html`<b>${displayPriceForAmount(hit, min)} - ${displayPriceForAmount(hit, max)}</b>`;
  }
  return html`<b>${displayPriceForAmount(hit, price)}</b>`;
}

/**
 * Returns a lowercase array of Shopify product tags from a hit.
 * Algolia's Shopify integration stores product tags in hit.tags (not hit._tags,
 * which contains internal Algolia faceting identifiers).
 */
function getHitTags(hit) {
  return Array.isArray(hit.tags) ? hit.tags.map(t => String(t).toLowerCase()) : [];
}

/**
 * Returns true if the hit has a store-scoped custom tag matching the given badge suffix.
 * Tag format in Shopify: "Custom: {PREFIX} {Suffix}" e.g. "Custom: FG Bestseller"
 * Algolia named tags parse this as named_tags['Custom'] = ' FG Bestseller' (leading space).
 * Prefix is set per store via window.siteBadgePrefix (body-scripts.liquid → settings.site).
 */
function hasStoreScopedTag(hit, suffix) {
  const prefix = String(window.siteBadgePrefix || '').toLowerCase();
  if (!prefix) return false;
  const customValue = String(hit.named_tags?.['Custom'] || '').trim().toLowerCase();
  return customValue === prefix + ' ' + suffix;
}

/**
 * Returns true if the Exclusive badge should show for this hit.
 * Tag format: "Custom: FG Exclusive" → named_tags['Custom'].trim() === 'FG Exclusive'
 */
function isExclusive(hit) {
  return hasStoreScopedTag(hit, 'exclusive');
}

/**
 * Returns true if the Special Edition badge should show for this hit.
 * Tag format: "Custom: FG Special Edition" → named_tags['Custom'].trim() === 'FG Special Edition'
 */
function isSpecialEdition(hit) {
  return hasStoreScopedTag(hit, 'special edition');
}

/**
 * Returns true if the Bestseller badge should show for this hit.
 * Checks store-scoped named tag first; falls back to legacy badge::best-seller named tag.
 * Algolia named tags parse "badge::best-seller" as named_tags.badge === ':best-seller'.
 */
function isBestseller(hit) {
  if (hasStoreScopedTag(hit, 'bestseller')) return true;
  return hit.named_tags?.['badge'] === ':best-seller';
}

/**
 * Returns true if the New badge should show for this hit.
 * Badge displays when publish_date_timestamp is within the past 90 days.
 * Automatically stops showing after 90 days with no manual action required.
 * Indexed in Algolia as a metafield: hit.meta.global.publish_date_timestamp (Number type).
 */
function isNew(hit) {
  const ts = Number(hit.meta?.global?.publish_date_timestamp);
  if (!Number.isFinite(ts) || ts <= 0) return false;
  const now = Math.floor(Date.now() / 1000);
  const ninetyDaysAgo = now - 7776000;
  return ts >= ninetyDaysAgo && ts <= now;
}

/**
 * Returns the sale discount percent for a hit, or null if the sale badge should not show.
 * Mirrors PDP logic in product-gallery.liquid:
 * - Requires promo_end_date metafield to be populated on the variant
 * - Requires compare_at_price > price
 * NOTE: promo_end_date must be indexed in Algolia under meta.global.promo_end_date
 */
function getSaleBadgePercent(hit) {
  if (!hit.meta?.global?.promo_end_date) return null;

  const price = Number(hit.price) || 0;
  const compareAt = Number(hit.compare_at_price) || 0;

  if (compareAt <= price || compareAt <= 0) return null;

  return Math.round((compareAt - price) / compareAt * 100);
}

/**
 * Returns true if the Low Stock badge should show for a hit.
 * Mirrors PDP logic in product-gallery.liquid:
 * - inventory_quantity > 0 and < window.lowStockThreshold (set from settings.low_stock_threshold via body-scripts.liquid)
 * - Suppressed for digital products (meta.global.digital), POD variants (_tags contains 'pod'),
 *   and pre-order variants (inventory_policy == 'continue')
 */
function isLowStock(hit) {
  const threshold = Number(window.lowStockThreshold) || 0;
  if (threshold === 0) return false;

  const qty = Number(hit.inventory_quantity);
  if (!Number.isFinite(qty) || qty <= 0 || qty >= threshold) return false;

  if (hit.meta?.global?.digital === true) return false;

  if (getHitTags(hit).includes('pod')) return false;

  if (hit.inventory_policy === 'continue') return false;

  return true;
}

/** True if compare-at exceeds price at either aggregate bound (any variant may be on sale). */
function algoliaHitHasAnyVariantOnSale(hit) {
  const minP = Number(hit.variants_min_price);
  const maxP = Number(hit.variants_max_price);
  const minC = Number(hit.variants_compare_at_price_min);
  const maxC = Number(hit.variants_compare_at_price_max);
  if (Number.isFinite(minC) && Number.isFinite(minP) && minC > minP) return true;
  if (Number.isFinite(maxC) && Number.isFinite(maxP) && maxC > maxP) return true;
  return false;
}

function isColorOptionName(name) {
  if (name == null || name === '') return false;
  const n = String(name).toLowerCase();
  return n === 'color' || n === 'colour';
}

/**
 * Color option label and value(s) from Algolia Shopify variant records
 * (option_names + options / option1–3). Returns null if no color is set.
 */
function getColorOptionDisplay(hit) {
  const optionsObj = hit && hit.options;
  if (!optionsObj || typeof optionsObj !== 'object') {
    return null;
  }

  const optionNames = Array.isArray(hit.option_names) ? hit.option_names : [];
  let label = null;
  let rawValue = null;

  const colorIdx = optionNames.findIndex(isColorOptionName);
  if (colorIdx !== -1) {
    label = optionNames[colorIdx];
    const key = optionNames[colorIdx];
    rawValue =
      optionsObj[key] ??
      optionsObj.Color ??
      optionsObj.color ??
      hit['option' + (colorIdx + 1)];
  }

  if (rawValue == null || rawValue === '') {
    rawValue = optionsObj.color ?? optionsObj.Color;
    if (rawValue != null && rawValue !== '') {
      label = label || 'Color';
    }
  }

  if (rawValue == null || rawValue === '') {
    return null;
  }

  const values = Array.isArray(rawValue)
    ? rawValue.map((v) => String(v).trim()).filter(Boolean)
    : [String(rawValue).trim()].filter(Boolean);

  if (!values.length) {
    return null;
  }

  return { label: label || 'Color', values };
}

/** Current hit’s color value; used to mark the selected swatch (matches algolia-old-custom-js). */
function getSwatchSelectedColorValue(hit) {
  const d = getColorOptionDisplay(hit);
  return d && d.values && d.values[0] ? d.values[0] : '';
}

function escapeAttrValue(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;');
}

function handleize(str) {
  let s = String(str).toLowerCase();
  const toReplace = ['"', "'", '\\', '(', ')', '[', ']'];
  for (let i = 0; i < toReplace.length; i++) {
    s = s.replace(toReplace[i], '');
  }
  s = s.replace(/\W+/g, '-');
  if (s.charAt(s.length - 1) === '-') {
    s = s.replace(/-+$/, '');
  }
  if (s.charAt(0) === '-') {
    s = s.replace(/^-+/, '');
  }
  return s;
}

function swatchColorFileBaseUrl() {
  if (typeof window !== 'undefined' && window.__ALGOLIA_SWATCH_COLOR_FILE_BASE__) {
    return window.__ALGOLIA_SWATCH_COLOR_FILE_BASE__;
  }
  return '//cdn.shopify.com/s/files/1/0049/1182/4965/files/color-';
}

function largeVariantImageUrl(src) {
  if (!src) return '';
  return String(src).replace(/(\.[^.]+)$/, '_large$1');
}

function isShopifyColorOption(option) {
  return option && (option.name === 'Color' || option.name === 'Colour');
}

const algoliaSwatchHydrationInflight = new WeakSet();

function maybeAppendMoreColorsButton(objectId) {
  const wrap = document.getElementById('ais-hit-swatches-' + objectId);
  const swatchesList = document.getElementById('ais-hit-swatches-list-' + objectId);
  if (!wrap || !swatchesList || wrap.classList.contains('expanded')) return;
  const moreId = 'ais-hit-swatches-more-' + objectId;
  if (swatchesList.clientHeight < swatchesList.scrollHeight && !document.getElementById(moreId)) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.id = moreId;
    btn.className = 'ais-hit-swatches--more';
    btn.textContent = 'More Colors +';
    btn.addEventListener('click', function () {
      btn.remove();
      swatchesList.style.height = 'auto';
      wrap.classList.add('expanded');
    });
    wrap.appendChild(btn);
  } else if (swatchesList.clientHeight >= swatchesList.scrollHeight) {
    const existing = document.getElementById(moreId);
    if (existing) existing.remove();
  }
}

function bindSwatchInteractions(hitEl, objectId) {
  const listEl = document.getElementById('ais-hit-swatches-list-' + objectId);
  const img = hitEl.querySelector('.ais-hit--picture');
  if (!listEl || !img) return;

  if (!img.dataset.defaultSrc) {
    img.dataset.defaultSrc = img.getAttribute('src') || '';
  }

  function previewFrom(swatch) {
    if (!swatch) return;
    const u = swatch.getAttribute('data-img');
    if (u) img.setAttribute('src', u);
  }

  function restoreAfterHover() {
    const selected = listEl.querySelector('a.ais-hit--swatch.selected');
    const fromSelected = selected && selected.getAttribute('data-img');
    if (fromSelected) {
      img.setAttribute('src', fromSelected);
      return;
    }
    if (img.dataset.defaultSrc) img.setAttribute('src', img.dataset.defaultSrc);
  }

  listEl.addEventListener('click', function (e) {
    const sw = e.target && e.target.closest && e.target.closest('a.ais-hit--swatch');
    if (!sw || !listEl.contains(sw)) return;
    e.stopPropagation();
    listEl.querySelectorAll('a.ais-hit--swatch').forEach(function (a) {
      a.classList.remove('selected');
    });
    sw.classList.add('selected');
    previewFrom(sw);
  });

  listEl.addEventListener('mouseover', function (e) {
    const sw = e.target && e.target.closest && e.target.closest('a.ais-hit--swatch');
    if (!sw || !listEl.contains(sw)) return;
    previewFrom(sw);
  });

  listEl.addEventListener('mouseleave', function () {
    restoreAfterHover();
  });
}

function hydrateAlgoliaProductColorSwatches() {
  document.querySelectorAll('.ais-hit.ais-product').forEach(function (hitEl) {
    if (hitEl.dataset.swatchesAlgoliaDone === '1') return;
    const mount = hitEl.querySelector('.ais-hit--swatches-mount');
    if (!mount) return;
    if (algoliaSwatchHydrationInflight.has(hitEl)) return;

    const handle = hitEl.getAttribute('data-handle');
    if (!handle) {
      hitEl.dataset.swatchesAlgoliaDone = '1';
      mount.remove();
      return;
    }

    algoliaSwatchHydrationInflight.add(hitEl);
    const objectId = hitEl.getAttribute('data-algolia-objectid') || '';
    const selectedColor = hitEl.getAttribute('data-swatch-color') || '';

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error(r.statusText);
        return r.json();
      })
      .then(function (product) {
        if (!hitEl.isConnected) return;

        const optionsArray = product.options || [];
        const variantsArray = product.variants || [];
        let colorOptionIndex = -1;
        for (let i = 0; i < optionsArray.length; i++) {
          if (isShopifyColorOption(optionsArray[i])) {
            colorOptionIndex = i;
            break;
          }
        }

        if (colorOptionIndex === -1) {
          hitEl.dataset.swatchesAlgoliaDone = '1';
          mount.remove();
          return;
        }

        const colorValues = (optionsArray[colorOptionIndex] && optionsArray[colorOptionIndex].values) || [];
        const base = swatchColorFileBaseUrl();
        let selectIt;
        let swatchesHtml = '';

        if (!colorValues.length) {
          hitEl.dataset.swatchesAlgoliaDone = '1';
          mount.remove();
          return;
        }

        for (let j = 0; j < colorValues.length; j++) {
          const thisColor = colorValues[j];
          if (thisColor === selectedColor) selectIt = j;
          let variantUrl = product.url || '';
          let variantImg = '';
          const swatchImg = base + handleize(thisColor) + '.png';

          for (let k = 0; k < variantsArray.length; k++) {
            const v = variantsArray[k];
            if (v.options && v.options[colorOptionIndex] === thisColor) {
              variantUrl = variantUrl.split('?')[0] + '?variant=' + v.id;
              if (v.featured_image != null) variantImg = v.featured_image.src;
              break;
            }
          }

          const selectedClass = j === selectIt ? ' selected' : '';
          const largeImg = largeVariantImageUrl(variantImg);
          const safeHref = escapeAttrValue(variantUrl);
          const safeDataImg = escapeAttrValue(largeImg || variantImg);
          const swatchStyle =
            "background-image:url('" + String(swatchImg).replace(/'/g, '%27') + "')";
          swatchesHtml +=
            '<a href="' +
            safeHref +
            '" class="ais-hit--swatch ais-color-swatch' +
            selectedClass +
            '" style="' +
            escapeAttrValue(swatchStyle) +
            '" data-img="' +
            safeDataImg +
            '" aria-label="' +
            escapeAttrValue('Swatch ' + (j + 1)) +
            '"></a>';
        }

        const wrap = document.createElement('div');
        wrap.id = 'ais-hit-swatches-' + objectId;
        wrap.className = 'ais-hit--swatches';
        wrap.innerHTML =
          '<div id="ais-hit-swatches-list-' +
          objectId +
          '" class="ais-hit--swatches-list">' +
          swatchesHtml +
          '</div>';

        mount.replaceWith(wrap);
        bindSwatchInteractions(hitEl, objectId);
        maybeAppendMoreColorsButton(objectId);
        hitEl.dataset.swatchesAlgoliaDone = '1';
      })
      .catch(function () {
        if (hitEl.isConnected && mount.parentNode) mount.remove();
        if (hitEl.isConnected) hitEl.dataset.swatchesAlgoliaDone = '1';
      })
      .finally(function () {
        algoliaSwatchHydrationInflight.delete(hitEl);
      });
  });
}

document.addEventListener('algolia.hooks.initialize', function () {
  if (window.__algoliaSwatchHydrationBound) return;
  window.__algoliaSwatchHydrationBound = true;

  let queued = false;
  function scheduleHydrate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      hydrateAlgoliaProductColorSwatches();
    });
  }

  const mo = new MutationObserver(scheduleHydrate);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  scheduleHydrate();

  window.addEventListener('resize', function () {
    document.querySelectorAll('.ais-hit--swatches:not(.expanded)').forEach(function (wrap) {
      const hit = wrap.closest('.ais-hit');
      const oid = hit && hit.getAttribute('data-algolia-objectid');
      if (oid) maybeAppendMoreColorsButton(oid);
    });
  });
});

document.addEventListener("algolia.hooks.initialize", () => {
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    (_defaultTemplate, 
      hit, 
      html, 
      components
    ) => {
      const metaGlobal = (hit && hit.meta && hit.meta.global) || {};
      const metafieldTitle = typeof metaGlobal.title === 'string' ? metaGlobal.title.trim() : '';
      const subtitle =
        metaGlobal.contributor ||
        metaGlobal.publisher ||
        metaGlobal.primary_contributors ||
        '';
      const displayTitle =
      metafieldTitle !== ''
        ? metafieldTitle
        : components.Highlight({ hit: hit, attribute: 'title' }); 
      const showSalePricing =
        (Number(hit.compare_at_price) || 0) > (Number(hit.price) || 0) ||
        algoliaHitHasAnyVariantOnSale(hit);
      const swatchSelectedColor = getSwatchSelectedColorValue(hit);
      const saleBadgePercent = getSaleBadgePercent(hit);
      const showLowStock = saleBadgePercent === null && isLowStock(hit);
      const noBadgeYet = saleBadgePercent === null && !showLowStock;
      const showExclusive = noBadgeYet && isExclusive(hit);
      const showSpecialEdition = noBadgeYet && !showExclusive && isSpecialEdition(hit);
      const showBestseller = noBadgeYet && !showExclusive && !showSpecialEdition && isBestseller(hit);
      const showNew = noBadgeYet && !showExclusive && !showSpecialEdition && !showBestseller && isNew(hit);
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        data-swatch-color="${escapeAttrValue(swatchSelectedColor)}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
        <div class="ais-hit--picture-wrap">
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.mediumImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
          />
          ${saleBadgePercent !== null && html`<div class="product-gallery-badge product-gallery-badge--sale h6">Save ${saleBadgePercent}%</div>`}
          ${showLowStock && html`<div class="product-gallery-badge product-gallery-badge--low-stock h6">Low Stock</div>`}
          ${showExclusive && html`<div class="product-gallery-badge product-gallery-badge--exclusive h6">Exclusive</div>`}
          ${showSpecialEdition && html`<div class="product-gallery-badge product-gallery-badge--special-edition h6">Special Edition</div>`}
          ${showBestseller && html`<div class="product-gallery-badge product-gallery-badge--best h6">Bestseller</div>`}
          ${showNew && html`<div class="product-gallery-badge product-gallery-badge--new h6">New</div>`}
          <button
            type="button"
            class="ais-hit--quickview-cta button ${window.brand === 'faith' ? 'button-secondary' : 'button-primary'}"
            data-quickview-trigger
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-product-id="${hit.id}"
            aria-label="Quick Buy"
            onClick="${(e) => {
              e.stopPropagation();
              e.preventDefault();
              algoliaQuickView.open({
                handle: hit.handle,
                variantId: hit.objectID,
                productId: hit.id,
              });
            }}"
          >
            Quick Buy
          </button>
          <button
            type="button"
            class="ais-hit--quickview-icon"
            data-quickview-trigger
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-product-id="${hit.id}"
            aria-label="Quick view"
            onClick="${(e) => {
              e.stopPropagation();
              e.preventDefault();
              algoliaQuickView.open({
                handle: hit.handle,
                variantId: hit.objectID,
                productId: hit.id,
              });
            }}"
          >
            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.476807 0.828736C1.37218 0.827883 1.91411 0.509941 2.14887 1.59216C2.26131 2.11046 2.20421 2.71487 2.2287 3.24916C2.28536 4.48546 2.30183 5.73107 2.40945 6.9642C2.46455 7.59546 2.43841 8.68332 2.88395 9.16987C3.30806 9.63302 4.32114 9.37924 4.86609 9.37765C6.25423 9.3736 7.64237 9.37425 9.03051 9.37959C9.72452 9.38225 10.4187 9.38262 11.1127 9.39104C11.4449 9.38911 11.777 9.3947 12.109 9.4078C12.5033 10.5559 12.3424 11.0882 11.6263 11.0048C11.0786 11.1886 10.1744 11.0302 9.59432 11.0403C8.91699 11.0522 8.23965 11.064 7.56231 11.0759C6.11087 11.1013 4.65944 11.1267 3.208 11.1521C2.77311 11.1597 2.77174 11.8366 3.208 11.8291C4.85296 11.8002 6.49792 11.7715 8.14288 11.7427C9.51716 11.7186 11.0376 11.8687 12.3975 11.6487C13.6713 11.4426 14.4705 9.90516 13.2091 9.05034C12.3375 8.45973 10.8895 8.71173 9.92287 8.70665C8.2373 8.69779 6.55169 8.6958 4.86609 8.70071C3.76258 8.70393 3.28004 8.53281 3.13729 7.39867C3.03306 6.57059 3.01905 5.73141 2.98086 4.89812C2.91217 3.39955 2.92636 1.87805 2.66401 0.398516C2.63844 0.254317 2.47613 0.149893 2.3378 0.150025C1.71747 0.150615 1.09714 0.151206 0.476807 0.151796C0.0414754 0.15221 0.0407186 0.829151 0.476807 0.828736Z" fill="#23262A" stroke="#23262A" stroke-width="0.3"/>
              <path d="M10.8634 13.4423C11.1527 13.5268 11.3742 13.949 11.3498 14.244C11.3193 14.6127 10.8179 14.8183 10.495 14.7671C9.84564 14.6642 10.1002 13.2364 10.753 13.4247C11.1722 13.5455 11.3511 12.8925 10.9329 12.7719C9.41516 12.3342 8.82922 15.1188 10.2922 15.4254C10.948 15.5628 11.7846 15.1911 11.9827 14.5216C12.1807 13.8522 11.7066 12.9834 11.0432 12.7895C10.6245 12.6671 10.4456 13.3201 10.8634 13.4423Z" fill="#23262A" stroke="#23262A" stroke-width="0.3"/>
              <path d="M5.49096 13.3938C5.77223 13.5777 6.0181 13.8869 5.90416 14.2438C5.79066 14.5993 5.4896 14.7526 5.12789 14.6338C4.82793 14.5354 4.82428 13.9416 4.84879 13.6759C4.8714 13.4308 4.97745 13.4179 5.20877 13.3902C5.38074 13.3696 5.56662 13.3877 5.73944 13.3918C6.17498 13.4023 6.1748 12.7254 5.73944 12.7149C5.0615 12.6985 4.3083 12.6652 4.19022 13.4996C4.10246 14.1197 4.20911 15.1163 4.93881 15.288C5.22268 15.3549 5.64925 15.3871 5.92208 15.2708C6.1877 15.1577 6.37994 14.8312 6.49348 14.5803C6.80752 13.8861 6.42187 13.1947 5.83245 12.8093C5.46692 12.5702 5.12751 13.1561 5.49096 13.3938Z" fill="#23262A" stroke="#23262A" stroke-width="0.3"/>
              <path d="M2.70678 3.28888C6.58722 3.29994 10.4677 3.311 14.3481 3.32206C14.2353 3.20924 14.1226 3.09642 14.0098 2.98359C13.8939 3.89917 12.9842 4.59343 12.6086 5.41272C12.1433 6.42761 12.1616 7.65652 11.8426 8.72797C11.7181 9.14637 12.3709 9.32512 12.495 8.90793C12.9024 7.53954 12.9051 6.16857 13.6941 4.94389C14.1147 4.29102 14.5873 3.76704 14.6864 2.98359C14.7095 2.80134 14.5127 2.64559 14.3481 2.64512C10.4677 2.63406 6.58722 2.623 2.70678 2.61194C2.27139 2.6107 2.27077 3.28764 2.70678 3.28888Z" fill="#23262A" stroke="#23262A" stroke-width="0.3"/>
            </svg>
          </button>
        </div>
        <div class="ais-hit--details">
        <div class="ais-hit--swatches-mount" aria-hidden="true"></div>
        <div class="yotpo bottomLine" data-product-id="${hit.id}" data-url="${hit.url}"></div>
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${displayTitle}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p class="ais-hit--subtitle">
            ${subtitle}
          </p>

          <p class="ais-hit--price">
            ${renderHitPriceDisplay(hit, html, showSalePricing)}
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${
              hit.sku &&
                html`
                  <span class="algolia-sku">
                    ${components.Highlight({ attribute: "sku", hit })}
                  </span>
                `
            }
            ${
              hit.barcode &&
                html`
                  <span class="algolia-barcode">
                    ${components.Highlight({ attribute: "barcode", hit })}
                  </span>
                `
            }
            ${
              hit.weight &&
                html`
                  <span class="algolia-weight">${hit.weight}</span>
                `
            }
            ${
              !hit.taxable &&
                html`
                  <span class="algolia-taxable">
                    ${algoliaShopify.translations.taxFree}
                  </span>
                `
            }
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult?.tags?.map(
              tag => html`<span class="ais-hit--tag">${tag.value}</span>`
            )}
          </p>
        </div>
      </div>
    `;
    }
  );
});

document.addEventListener("algolia.hooks.initialize", () => {
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchStatsTemplate",
    (_defaultTemplate, data, html) => {
      // For pages that return multiple results, customize the text:
      if (data.hasManyResults) {
        const start = data.page * data.hitsPerPage + 1;
        const end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits);

        return html`
          <span class="ais-stats--nb-results">
            ${start}-${end} items out of ${algoliaShopify.helpers.formatNumber(data.nbHits)}
          </span>
        `;
      }
      // For 1 result
      if (data.hasOneResult) {
        return html`<span class="ais-stats--nb-results">1 item found</span>`;
      }
      // For no results
      return html`<span class="ais-stats--nb-results">No items found</span>`;
    }
  );
});



/** Add $ symbols to price_range chips in .ais-current-refined-values--list. */
function formatCurrentRefinedPriceRanges() {
  document
    .querySelectorAll(
      '.ais-current-refined-values--list .ais-current-refined-values--link[data-attribute="price_range"]'
    )
    .forEach(function (link) {
      var labelEl = link.querySelector('.ais-current-refined-values--label');
      if (!labelEl) return;
      var text = (link.getAttribute('data-value') || '').trim();
      if (!text) return;

      var words = text.split('%3A');
      if (words.length >= 2) {
        var min_price = words[0];
        var max_price = words[1];
        link.innerHTML = '<div><div class="ais-current-refined-values--label">Price range</div> : ' + '$'+ min_price + ' - $' + max_price + '</div>';
      } else {
        link.innerHTML = '<div><div class="ais-current-refined-values--label">Price range</div> : ' + '$'+ text + '</div>';
      }
    });
}

document.addEventListener("algolia.instantSearch.onRender", function () {
  // 1. Insert "Filter By" as first child of .ais-facets
  var facetsContainer = document.querySelector('.ais-facets');
  if (facetsContainer && !facetsContainer.querySelector('.ais-facets-title')) {
    var title = document.createElement('h4');
    title.className = 'ais-facets-title';
    title.textContent = 'Filter By';
    facetsContainer.insertBefore(title, facetsContainer.firstChild);
  }

  // 2. Change all .ais-facet--checkbox to .ais-facet--checkbox__custom
  var checkboxes = document.querySelectorAll('.ais-facet--checkbox');
  checkboxes.forEach(function(el) {
    el.classList.remove('ais-facet--checkbox');
    el.classList.add('ais-facet--checkbox__custom');
  });

  // 3. Add form-control and checkbox classes to .ais-RefinementList-label.ais-facet--label
  var refinementLabels = document.querySelectorAll('.ais-RefinementList-label.ais-facet--label');
  refinementLabels.forEach(function(el) {
    el.classList.add('form-control', 'checkbox');
  });

  // 4. Format price_range active filters with $ symbols
  formatCurrentRefinedPriceRanges();
});

function isAlgoliaColorFacet(facet) {
  const name = String(facet?.name || '').toLowerCase();
  const title = String(facet?.title || '').toLowerCase();
  return (
    name === 'color' ||
    name === 'colour' ||
    name === 'options.color' ||
    name === 'options.colour' ||
    name.endsWith('.color') ||
    name.endsWith('.colour') ||
    title === 'color' ||
    title === 'colour'
  );
}

const ALGOLIA_COLOR_FACET_LIMIT = 100;

/** Same file-based swatch image as product cards; `label` is the facet value (e.g. "Navy"). */
function facetColorSwatchBackgroundStyle(label) {
  const url = swatchColorFileBaseUrl() + handleize(String(label ?? '')) + '.png';
  return "background-image:url('" + String(url).replace(/'/g, '%27') + "')";
}

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchFacetParamsOptions',
    function (params, facet) {
      // COLOR FACET LOGIC
      if (typeof isAlgoliaColorFacet === "function" && isAlgoliaColorFacet(facet)) {
        return {
          ...params,
          limit: ALGOLIA_COLOR_FACET_LIMIT,
          showMore: false,
          templates: {
            ...params.templates,
            item(item, { html }) {
              const labelText = item.label != null ? item.label : item.value;
              const swatchStyle = facetColorSwatchBackgroundStyle(labelText);
              // SC 2.1.1 — the swatch needs a real focusable control. Without
              // the checkbox this row was a <label> wrapping two spans: one
              // aria-hidden, one display:none, so it was mouse-only and had no
              // accessible name. The checkbox is visually hidden but focusable
              // (see .ais-facet-color-checkbox in algolia-custom.scss).
              return html`
                <label class="ais-facet-color-row">
                  <input
                    type="checkbox"
                    class="ais-facet-color-checkbox"
                    checked="${!!item.isRefined}"
                    aria-label="${labelText} (${item.count})"
                  />
                  <span
                    class="ais-color-swatch ais-facet-color-swatch"
                    style="${swatchStyle}"
                    aria-hidden="true"
                  ></span>
                  <span class="ais-facet-color-row__text hidden">${item.label} (${item.count})</span>
                </label>
              `;
            },
          },
        };
      }

      // YOTPO RATINGS: Only show "4 & up", "3 & up", "2 & up", "1 & up"
      if (
        facet.name === "meta.yotpo.reviews_average" ||
        facet.attribute === "meta.yotpo.reviews_average"
      ) {
        // NOTE: Skipping '5 & up' and starting from 4
        const groupedStars = [5, 4, 3, 2, 1];
        return {
          ...params,
          transformItems(items) {
            // Pre-parse numeric labels
            const parsedItems = items.map(item => ({
              ...item,
              rating: parseFloat(item.label)
            }));
            return groupedStars.map(star => {
              const count = parsedItems
                .filter(item => item.rating >= star)
                .reduce((sum, item) => sum + item.count, 0);
              return {
                label: `${star} & up`,
                value: `${star}`,
                count,
                stars: star
              };
            }).filter(item => item.count > 0);
          },
          templates: {
            ...params.templates,
            item(item, { html }) {
              const maxStars = 5;
              const value = parseInt(item.stars, 10) || 0;
              const fullStar = html`<svg aria-hidden="true" viewBox="0 0 18 18" width="15" height="15" xmlns="http://www.w3.org/2000/svg" style="display:inline-block;margin-right:4px;vertical-align:baseline;"><defs><linearGradient id="yotpo_stars_gradient_0.4565670526652197"><stop offset="100%" stop-color="rgba(238,163,19,1)"></stop><stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop></linearGradient></defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#D8790E" fill="#D8790E"></path></svg>`;
              const emptyStar = html`<svg aria-hidden="true" viewBox="0 0 18 18" width="15" height="15" xmlns="http://www.w3.org/2000/svg" style="display:inline-block;margin-right:4px;vertical-align:baseline"><defs><linearGradient id="yotpo_stars_gradient_0.4565670526652197"><stop offset="100%" stop-color="rgba(238,163,19,1)"></stop><stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop></linearGradient></defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#D8790E" fill="white"></path></svg>`;

              const stars = Array.from({ length: maxStars }, (_, i) =>
                i < value ? fullStar : emptyStar
              );
              return html`
                <label class="ais-facet-rating-row">
                  <span class="ais-rating-stars">${stars}</span>
                  <span class="ais-rating-label" style="margin-left:8px;">${item.label}</span>
                  <span class="ais-RefinementList-count ais-facet--count-distinct" style="margin-left:5px;">${item.count}</span>
                </label>
              `;
            },
          },
        };
      }

      // Default for all other facets
      return params;
    }
  );
});

document.addEventListener('algolia.instantSearch.onRender', function() {
  // Re-render reviews (e.g., Yotpo)
  if (typeof Yotpo !== 'undefined') {
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }
});

// document.addEventListener("algolia.hooks.initialize", () => {
//   algoliaShopify.hooks.registerHook(
//     "beforeInstantSearchMainTemplate",
//     (_defaultTemplate, data, html) => html`
//       <div>
//         ...
//         <div class="ais-sort">
//           ${algoliaShopify.translations.sortBy}
//           <span class="ais-sort-orders-container"></span>
//         </div>
//         ...
//       </div>
//     `
//   );
// });

/* Quick View Modal */

var algoliaQuickView = (function () {
  var MODAL_ID = 'ais-quickview-modal';
  var rootEl = null;
  var contentEl = null;
  var state = {
    open: false,
    handle: null,
    product: null,
    productView: null,
    currentVariant: null,
    qty: 1,
    animGen: 0,
    loadSeq: 0,
  };

  function formatMoney(cents) {
    var n = Number(cents);
    if (!Number.isFinite(n)) return '';
    return '$' + (n / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatDateMDY(date) {
    return pad2(date.getMonth() + 1) + '/' + pad2(date.getDate()) + '/' + date.getFullYear();
  }

  function parseDate(value) {
    if (!value) return null;
    var d = new Date(value);
    if (isNaN(d.getTime())) {
      var parts = String(value).split('-');
      if (parts.length === 3) {
        d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      }
    }
    return isNaN(d.getTime()) ? null : d;
  }

  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function isGuest() {
    if (document.body.classList.contains('product--not-loggedin')) return true;
    if (typeof window.loggedIn === 'boolean') return window.loggedIn === false;
    return false;
  }

  function getLoginBase() {
    if (typeof window.loginUrl === 'string' && window.loginUrl.length) {
      var idx = window.loginUrl.indexOf('&returnTo=');
      if (idx > -1) return window.loginUrl.substring(0, idx);
      return window.loginUrl;
    }
    return '';
  }

  function buildLoginHref(variantUrl) {
    var base = getLoginBase();
    if (!base) return '#';
    var origin = window.location.origin || '';
    return base + '&returnTo=' + origin + variantUrl;
  }

  function variantOptionValue(variant, idx) {
    if (!variant || idx < 0) return '';
    if (Array.isArray(variant.options)) {
      return variant.options[idx] || '';
    }
    return variant['option' + (idx + 1)] || '';
  }

  function isTruthyMetafieldValue(value) {
    if (value === true) return true;
    if (value === false || value == null) return false;
    if (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')) {
      return isTruthyMetafieldValue(value.value);
    }
    return String(value).trim() !== '' && String(value).toLowerCase() !== 'false';
  }

  function variantIsDigital(variant) {
    var meta = (variant && variant.metafields) || {};
    return isTruthyMetafieldValue(meta.digital);
  }

  function findVariantForOption(product, currentVariant, optionIndex, newValue) {
    var variants = (product && product.variants) || [];
    var numOptions = ((product && product.options) || []).length;
    if (!variants.length || optionIndex < 0) return null;

    var desired = [];
    for (var i = 0; i < numOptions; i++) {
      desired.push(i === optionIndex ? newValue : variantOptionValue(currentVariant, i));
    }

    function pickByPrefixLength(prefixLen) {
      var fallback = null;
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        var ok = true;
        for (var k = 0; k < prefixLen; k++) {
          if (variantOptionValue(v, k) !== desired[k]) {
            ok = false;
            break;
          }
        }
        if (!ok) continue;
        if (v.available) return v;
        if (!fallback) fallback = v;
      }
      return fallback;
    }

    var match = pickByPrefixLength(numOptions);
    if (match) return match;

    for (var prefix = optionIndex + 1; prefix >= 1; prefix--) {
      match = pickByPrefixLength(prefix);
      if (match) return match;
    }
    return null;
  }

  function isValueReachable(product, currentVariant, optionIndex, value) {
    var variants = (product && product.variants) || [];
    if (!variants.length) return false;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (variantOptionValue(v, optionIndex) !== value) continue;
      var ok = true;
      for (var k = 0; k < optionIndex; k++) {
        if (variantOptionValue(v, k) !== variantOptionValue(currentVariant, k)) {
          ok = false;
          break;
        }
      }
      if (ok) return true;
    }
    return false;
  }

  function variantFeaturedImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return largeVariantImageUrl(variant.featured_image.src);
    }
    if (product && product.featured_image) {
      return product.featured_image;
    }
    return '';
  }

  function getMergedMetafields(product, viewVariant) {
    var meta = (viewVariant && viewVariant.metafields) || {};
    return meta;
  }

  function getViewVariant(productView, variantId) {
    if (!productView || !Array.isArray(productView.variants)) return null;
    return (
      productView.variants.find(function (v) {
        return String(v.id) === String(variantId);
      }) || null
    );
  }

  function ensureModalRoot() {
    if (rootEl && document.body.contains(rootEl)) return rootEl;
    rootEl = document.createElement('div');
    rootEl.id = MODAL_ID;
    rootEl.className = 'ais-quickview hidden';
    rootEl.setAttribute('role', 'dialog');
    rootEl.setAttribute('aria-modal', 'true');
    rootEl.setAttribute('aria-hidden', 'true');
    rootEl.innerHTML =
      '<div class="ais-quickview__backdrop" data-quickview-close></div>' +
      '<div class="ais-quickview__panel" role="document">' +
      '  <button type="button" class="ais-quickview__close" data-quickview-close aria-label="Close Quick View">' +
      '    <svg viewBox="0 0 16 16" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '      <path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '    </svg>' +
      '  </button>' +
      '  <div class="ais-quickview__content" data-quickview-content></div>' +
      '</div>';
    document.body.appendChild(rootEl);
    contentEl = rootEl.querySelector('[data-quickview-content]');

    rootEl.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-quickview-close]')) {
        close();
      }
    });

    return rootEl;
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      close();
    }
  }

  let lastTrigger = null;

  var CLOSE_ANIM_MS = 330;

  function finishClose(closeGen) {
    if (!rootEl || state.open || state.animGen !== closeGen) return;
    rootEl.classList.remove('is-closing');
    rootEl.classList.add('hidden');
    document.body.classList.remove('no-scroll');

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    document.removeEventListener('keydown', onKeyDown);

    if (rootEl) {
      rootEl.classList.remove('is-open');
      rootEl.classList.add('is-closing');
      rootEl.setAttribute('aria-hidden', 'true');
      var closeGen = ++state.animGen;
      var panel = rootEl.querySelector('.ais-quickview__panel');
      var ended = false;

      function onCloseEnd(e) {
        if (ended) return;
        if (e && e.target !== panel) return;
        ended = true;
        if (panel) {
          panel.removeEventListener('transitionend', onCloseEnd);
        }
        finishClose(closeGen);
      }

      if (panel) {
        panel.addEventListener('transitionend', onCloseEnd);
      }

      window.setTimeout(function () {
        onCloseEnd();
      }, CLOSE_ANIM_MS);
    } else {
      document.body.classList.remove('no-scroll');
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
      lastTrigger = null;
    }
  }

  function renderSkeleton() {
    contentEl.innerHTML =
      '<div class="ais-quickview__grid">' +
      '  <div class="ais-quickview__image-col"><div class="ais-quickview--skeleton-image"></div></div>' +
      '  <div class="ais-quickview__details-col"><div class="ais-quickview--skeleton-lines"><span></span><span></span><span></span></div></div>' +
      '</div>';
  }

  function buildSwatchListMarkup(values, currentValue, optionPosition) {
    var base = swatchColorFileBaseUrl();
    var html = '<div class="ais-quickview--swatches" role="list">';
    for (var i = 0; i < values.length; i++) {
      var val = values[i];
      var selected = val === currentValue ? ' selected' : '';
      var img = base + handleize(val) + '.png';
      var style = "background-image:url('" + String(img).replace(/'/g, '%27') + "')";
      html +=
        '<button type="button" role="listitem" class="ais-quickview--swatch ais-color-swatch' +
        selected +
        '" data-option-position="' +
        optionPosition +
        '" data-option-value="' +
        escapeAttrValue(val) +
        '" style="' +
        escapeAttrValue(style) +
        '" aria-label="' +
        escapeAttrValue(val) +
        '"></button>';
    }
    html += '</div>';
    return html;
  }

  function buildButtonListMarkup(values, currentValue, optionPosition, opts) {
    opts = opts || {};
    var altVariantName = opts.alternativeVariantName || '';
    var falseVariants = Array.isArray(opts.falseVariants) ? opts.falseVariants : [];
    var falseVariantsFirst = !!opts.falseVariantsFirst;

    function falseVariantButtons() {
      return falseVariants
        .map(function (fv) {
          var label = fv.label || fv.title || '';
          return (
            '<a href="' +
            escapeAttrValue(fv.url || '#') +
            '" class="ais-quickview--option-button ais-quickview--option-link" data-option-false-variant data-false-variant-handle="' +
            escapeAttrValue(fv.handle || '') +
            '">' +
            escapeAttrValue(label) +
            '</a>'
          );
        })
        .join('');
    }

    function nativeButtons() {
      return values
        .map(function (val) {
          var label = altVariantName || val;
          var active = val === currentValue ? ' active' : '';
          return (
            '<button type="button" class="ais-quickview--option-button' +
            active +
            '" data-option-position="' +
            optionPosition +
            '" data-option-value="' +
            escapeAttrValue(val) +
            '">' +
            escapeAttrValue(label) +
            '</button>'
          );
        })
        .join('');
    }

    var first = falseVariantsFirst ? falseVariantButtons() : '';
    var last = falseVariantsFirst ? '' : falseVariantButtons();
    return '<div class="ais-quickview--option-buttons">' + first + nativeButtons() + last + '</div>';
  }

  function isShopifyBundleProduct(product) {
    return !!(
      product &&
      Array.isArray(product.tags) &&
      product.tags.some(function (tag) {
        return String(tag || '').toLowerCase() === 'bundle';
      })
    );
  }

  function buildBundleOptionsMarkup(product, view) {
    var falseVariants = getFormatFalseVariants(view);
    if (!falseVariants.length) return '';

    var currentLabel = getAlternativeVariantName(view) || 'Bundle';
    var falseVariantsFirst = isSetProductType(product) === false;
    var falseVariantHtml = falseVariants
      .map(function (fv) {
        var label = fv.label || fv.title || '';
        return (
          '<a href="' +
          escapeAttrValue(fv.url || '#') +
          '" class="ais-quickview--option-button ais-quickview--option-link" data-option-false-variant data-false-variant-handle="' +
          escapeAttrValue(fv.handle || '') +
          '">' +
          escapeAttrValue(label) +
          '</a>'
        );
      })
      .join('');

    var currentButton =
      '<button type="button" class="ais-quickview--option-button active">' +
      escapeAttrValue(currentLabel) +
      '</button>';

    return (
      '<div class="ais-quickview--options" data-qv-options>' +
      '<div class="ais-quickview--option-row" data-option-name="Format">' +
      '<p class="ais-quickview--option-row-label">' +
      '<span class="ais-quickview--option-label">Format:</span> ' +
      '<span data-qv-option-current="format">Bundle</span>' +
      '</p>' +
      '<div class="ais-quickview--option-buttons">' +
      (falseVariantsFirst ? falseVariantHtml + currentButton : currentButton + falseVariantHtml) +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function buildOptionsMarkup(product, view, variant) {
    var options = getOptionList(product, view);
    if (!options.length) return buildBundleOptionsMarkup(product, view);

    var altVariantName = getAlternativeVariantName(view);
    var formatFalseVariants = getFormatFalseVariants(view);
    var falseVariantsFirst = isSetProductType(product) === false;

    var html = '<div class="ais-quickview--options" data-qv-options>';
    var renderedCount = 0;
    options.forEach(function (opt) {
      if (isDefaultTitleOption(opt)) return;
      renderedCount += 1;

      var currentValue = variantOptionValue(variant, opt.position);
      var name = opt.name || '';
      var nameHandle = handleize(name);
      var isColor = isColorOptionByName(name);
      var isFormat = isFormatOptionByName(name);

      html +=
        '<div class="ais-quickview--option-row" data-option-position="' +
        opt.position +
        '" data-option-name="' +
        escapeAttrValue(name) +
        '">' +
        '<p class="ais-quickview--option-row-label">' +
        '<span class="ais-quickview--option-label">' +
        escapeAttrValue(name) +
        ':</span> ' +
        '<span data-qv-option-current="' +
        nameHandle +
        '">' +
        escapeAttrValue(currentValue || '') +
        '</span>' +
        '</p>';

      if (isColor) {
        html += buildSwatchListMarkup(opt.values, currentValue, opt.position);
      } else {
        html += buildButtonListMarkup(opt.values, currentValue, opt.position, {
          alternativeVariantName: isFormat ? altVariantName : '',
          falseVariants: isFormat ? formatFalseVariants : [],
          falseVariantsFirst: isFormat ? falseVariantsFirst : false,
        });
      }

      html += '</div>';
    });
    html += '</div>';
    if (!renderedCount && isShopifyBundleProduct(product)) {
      return buildBundleOptionsMarkup(product, view);
    }
    return html;
  }

  function priceMarkup(variant) {
    var price = Number(variant && variant.price) || 0;
    var compare = Number(variant && variant.compare_at_price) || 0;
    var onSale = compare > price;
    if (onSale) {
      return (
        '<span class="ais-quickview--price-sale">' +
        formatMoney(price) +
        '</span>' +
        '<span class="ais-quickview--price-striked">' +
        formatMoney(compare) +
        '</span>'
      );
    }
    return '<b class="ais-quickview--price-amount">' + formatMoney(price) + '</b>';
  }

  function getViewMetaField(view, variant, key) {
    if (!view || !view.variants) return '';
    if (variant) {
      var v = getViewVariant(view, variant.id);
      if (v && v.metafields && v.metafields[key]) return v.metafields[key];
    }
    var v0 = view.variants[0];
    var meta0 = (v0 && v0.metafields) || {};
    return meta0[key] || '';
  }

  function getVariantTitle(product, view, variant) {
    var metaTitle = getViewMetaField(view, variant, 'title');
    if (metaTitle) return metaTitle;
    return (product && product.title) || '';
  }

  function getVariantSubtitle(view, variant) {
    return getViewMetaField(view, variant, 'subtitle') || '';
  }

  function getContributor(view, variant) {
    var contributor = getViewMetaField(view, variant, 'contributor');
    var publisher = getViewMetaField(view, variant, 'publisher');
    var primaryContributors = getViewMetaField(view, variant, 'primary_contributors');
    return (
      (contributor && String(contributor).trim()) ||
      (publisher && String(publisher).trim()) ||
      (primaryContributors && String(primaryContributors).trim()) ||
      ''
    );
  }

  function getSeries(view, variant) {
    return getViewMetaField(view, variant, 'series') || '';
  }

  function isColorOptionByName(name) {
    var n = String(name || '').toLowerCase();
    return n === 'color' || n === 'colour';
  }

  function isFormatOptionByName(name) {
    return String(name || '').toLowerCase() === 'format';
  }

  function isDefaultTitleOption(option) {
    if (!option) return false;
    var name = String(option.name || '').toLowerCase();
    var values = Array.isArray(option.values) ? option.values : [];
    var hasOnlyDefaultTitle =
      values.length === 1 && String(values[0] || '').toLowerCase() === 'default title';
    return name === 'title' || hasOnlyDefaultTitle;
  }

  function getOptionList(product, view) {
    if (view && Array.isArray(view.options_with_values) && view.options_with_values.length) {
      return view.options_with_values.map(function (o, idx) {
        return {
          name: o && o.name ? o.name : '',
          position: typeof o.position === 'number' ? o.position - 1 : idx,
          values: Array.isArray(o && o.values) ? o.values : [],
        };
      });
    }

    var rawOptions = (product && product.options) || [];
    var names = rawOptions.map(function (o) {
      return typeof o === 'string' ? o : (o && o.name) || '';
    });

    return names.map(function (name, idx) {
      var seen = {};
      var values = [];
      (product.variants || []).forEach(function (v) {
        var val = variantOptionValue(v, idx);
        if (val && !seen[val]) {
          seen[val] = true;
          values.push(val);
        }
      });
      return { name: name, position: idx, values: values };
    });
  }

  function isSetProductType(product) {
    if (!product || !product.type) return false;
    return handleize(product.type).indexOf('-set') !== -1;
  }

  function getFormatFalseVariants(view) {
    var pm = view && view.product_metafields;
    if (!pm || !Array.isArray(pm.false_variants) || !pm.false_variants.length) return [];
    var labels = Array.isArray(pm.false_variants_label) ? pm.false_variants_label : [];
    return pm.false_variants.map(function (fv, idx) {
      return {
        url: (fv && fv.url) || '',
        title: (fv && fv.title) || '',
        handle: (fv && fv.handle) || '',
        label: labels[idx] || '',
      };
    });
  }

  function getAlternativeVariantName(view) {
    var pm = view && view.product_metafields;
    return (pm && pm.alternative_variant_name) || '';
  }

  function buildQuickviewBadge(product, view, variant) {
    var productTags = Array.isArray(view && view.tags)
      ? view.tags.map(function (t) { return String(t).toLowerCase(); })
      : (Array.isArray(product && product.tags)
          ? product.tags.map(function (t) { return String(t).toLowerCase(); })
          : []);

    var viewVariant = null;
    if (view && Array.isArray(view.variants) && variant) {
      viewVariant = view.variants.find(function (v) { return v.id === variant.id; }) || null;
    }
    var mf = (viewVariant && viewVariant.metafields) || {};

    // 1. Sale
    var compareAt = (variant && variant.compare_at_price) || 0;
    var price = (variant && variant.price) || 0;
    var salePct = (mf.promo && compareAt > price && compareAt > 0)
      ? Math.round(((compareAt - price) / compareAt) * 100)
      : null;

    // 2. Low Stock
    // inventory_quantity is NOT exposed by Shopify's /products/{handle}.js endpoint.
    // Read it from viewVariant (product.json.liquid) which has it via Liquid.
    var threshold = Number(window.lowStockThreshold) || 0;
    var invQty = viewVariant != null && viewVariant.inventory_quantity != null
      ? Number(viewVariant.inventory_quantity)
      : 0;
    var isDigital = !!mf.digital;
    var isPod = productTags.some(function (t) { return t === 'pod'; });
    var isPreorder = variant && variant.inventory_policy === 'continue';
    var showLowStock = salePct === null && threshold > 0 && !isDigital && !isPod && !isPreorder && invQty > 0 && invQty < threshold;

    // 3. Exclusive
    var prefix = String(window.siteBadgePrefix || '').toLowerCase();
    var showExclusive = salePct === null && !showLowStock && prefix && productTags.some(function (t) { return t === 'custom: ' + prefix + ' exclusive'; });

    // 4. Special Edition
    var showSpecialEdition = salePct === null && !showLowStock && !showExclusive && prefix && productTags.some(function (t) { return t === 'custom: ' + prefix + ' special edition'; });

    // 5. Bestseller
    var showBestseller = salePct === null && !showLowStock && !showExclusive && !showSpecialEdition && (
      (prefix && productTags.some(function (t) { return t === 'custom: ' + prefix + ' bestseller'; })) ||
      productTags.some(function (t) { return t.includes('badge::best'); })
    );

    // 6. New — publish_date within past 90 days
    var publishDate = mf.publish_date;
    var showNew = false;
    if (salePct === null && !showLowStock && !showExclusive && !showSpecialEdition && !showBestseller && publishDate) {
      var ts = Math.floor(new Date(publishDate).getTime() / 1000);
      var now = Math.floor(Date.now() / 1000);
      showNew = ts >= now - 7776000 && ts <= now;
    }

    if (salePct !== null) {
      return '<div class="product-gallery-badge product-gallery-badge--sale h6">Save ' + salePct + '%</div>';
    }
    if (showLowStock) {
      return '<div class="product-gallery-badge product-gallery-badge--low-stock h6">Low Stock</div>';
    }
    if (showExclusive) {
      return '<div class="product-gallery-badge product-gallery-badge--exclusive h6">Exclusive</div>';
    }
    if (showSpecialEdition) {
      return '<div class="product-gallery-badge product-gallery-badge--special-edition h6">Special Edition</div>';
    }
    if (showBestseller) {
      return '<div class="product-gallery-badge product-gallery-badge--best h6">Bestseller</div>';
    }
    if (showNew) {
      return '<div class="product-gallery-badge product-gallery-badge--new h6">New</div>';
    }

    return '';
  }

  function renderLayout() {
    var product = state.product;
    var view = state.productView;
    var variant = state.currentVariant;
    if (!product || !variant) {
      renderSkeleton();
      return;
    }

    var imgSrc = variantFeaturedImage(product, variant);
    var series = getSeries(view, variant);
    var titleText = getVariantTitle(product, view, variant);
    var subtitle = getVariantSubtitle(view, variant);
    var contributor = getContributor(view, variant);
    var variantUrl = product.url + '?variant=' + variant.id;
    var optionsHtml = buildOptionsMarkup(product, view, variant);
    var badgeHtml = buildQuickviewBadge(product, view, variant);

    var html =
      '<div class="ais-quickview__grid">' +
      '  <div class="ais-quickview__image-col">' +
      '    <div class="ais-quickview__image-frame">' +
      '      <div data-qv-badge>' + badgeHtml + '</div>' +
      '      <img class="ais-quickview--image" data-qv-image src="' +
      escapeAttrValue(imgSrc) +
      '" alt="' +
      escapeAttrValue(titleText) +
      '" />' +
      '    </div>' +
      '    <a class="ais-quickview--details-link button-text desktop-only" data-qv-details-link href="' +
      escapeAttrValue(variantUrl) +
      '">View all details</a>' +
      '  </div>' +
      '  <div class="ais-quickview__details-col">' +
      (series ? '<p class="ais-quickview--series" data-qv-series>Series: ' + escapeAttrValue(series) + '</p>' : '<p class="ais-quickview--series hidden" data-qv-series></p>') +
      '    <h2 class="ais-quickview--title" data-qv-title>' +
      escapeAttrValue(titleText) +
      '</h2>' +
      '    <h3 class="ais-quickview--subtitle' +
      (subtitle ? '' : ' hidden') +
      '" data-qv-subtitle>' +
      escapeAttrValue(subtitle) +
      '</h3>' +
      (contributor ? '<span class="ais-quickview--contributor text-p-s mb-3" data-qv-contributor>' + escapeAttrValue(contributor) + '</span>' : '<span class="ais-quickview--contributor hidden" data-qv-contributor></span>') + 
      '    <div class="ais-quickview--reviews">' +
      '      <div class="yotpo bottomLine" data-product-id="' +
      escapeAttrValue(product.id) +
      '" data-url="' +
      escapeAttrValue(product.url) +
      '"></div>' +
      '    </div>' +
      '    <p class="ais-quickview--price" data-qv-price>' +
      priceMarkup(variant) +
      '    </p>' +
      optionsHtml +
      '    <div class="ais-quickview__details-link-wrapper">' +
      '      <a class="ais-quickview--details-link button-text mobile-only" data-qv-details-link href="' +
      escapeAttrValue(variantUrl) +
      '">View all details</a>' +
      '    </div>' +
      '    <div class="ais-quickview--actions">' +
      '      <div class="ais-quickview--qty" data-qv-qty>' +
      '        <button type="button" class="ais-quickview--qty-btn" data-qv-qty-dec aria-label="Decrease quantity">&minus;</button>' +
      '        <input type="number" class="ais-quickview--qty-input" data-qv-qty-input value="1" min="1" inputmode="numeric" aria-label="Quantity" />' +
      '        <button type="button" class="ais-quickview--qty-btn" data-qv-qty-inc aria-label="Increase quantity">+</button>' +
      '      </div>' +
      '      <button type="button" class="ais-quickview--atc button ' +
      (window.brand === 'faith' ? 'button-secondary' : 'button-primary') +
      '" data-qv-atc>' +
      '        <span data-qv-atc-text>Add to Cart</span>' +
      '      </button>' +
      '      <a href="#" class="ais-quickview--login button ' +
      (window.brand === 'faith' ? 'button-secondary' : 'button-primary') +
      ' hidden" data-qv-login data-atc-login-btn>' +
      '        <span>Log In to Buy</span>' +
      '      </a>' +
      '    </div>' +
      '  </div>' +
      '</div>';

    contentEl.innerHTML = html;

    bindLayoutEvents();
    setQuickViewVariant(variant.id, { initial: true });
    refreshYotpo();
  }

  function refreshYotpo() {
    try {
      if (typeof Yotpo !== 'undefined' && typeof yotpo !== 'undefined') {
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      }
    } catch (_) {}
  }

  function bindLayoutEvents() {
    var dec = contentEl.querySelector('[data-qv-qty-dec]');
    var inc = contentEl.querySelector('[data-qv-qty-inc]');
    var input = contentEl.querySelector('[data-qv-qty-input]');

    if (dec) {
      dec.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        state.qty = v;
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
        input.value = v;
        state.qty = v;
      });
    }
    if (input) {
      input.addEventListener('change', function () {
        var v = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = v;
        state.qty = v;
      });
    }

    var optionsRoot = contentEl.querySelector('[data-qv-options]');
    if (optionsRoot) {
      optionsRoot.addEventListener('click', function (e) {
        var falseBtn = e.target && e.target.closest && e.target.closest('[data-option-false-variant]');
        if (falseBtn && optionsRoot.contains(falseBtn)) {
          e.preventDefault();
          var falseHandle = falseBtn.getAttribute('data-false-variant-handle');
          if (falseHandle) {
            loadProductIntoModal({ handle: falseHandle });
          }
          return;
        }

        var btn = e.target && e.target.closest && e.target.closest('[data-option-value]');
        if (!btn || !optionsRoot.contains(btn)) return;
        if (btn.classList.contains('is-unavailable') || btn.hasAttribute('disabled')) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        var positionAttr = btn.getAttribute('data-option-position');
        var position = parseInt(positionAttr, 10);
        var value = btn.getAttribute('data-option-value');
        if (Number.isNaN(position) || value == null) return;
        var nextVariant = findVariantForOption(state.product, state.currentVariant, position, value);
        if (nextVariant) setQuickViewVariant(nextVariant.id);
      });
    }

    var atc = contentEl.querySelector('[data-qv-atc]');
    if (atc) {
      atc.addEventListener('click', onAddToCartClick);
    }
  }

  function disableAtc(text, disabled) {
    var atc = contentEl.querySelector('[data-qv-atc]');
    var atcText = contentEl.querySelector('[data-qv-atc-text]');
    if (!atc || !atcText) return;
    atcText.textContent = text;
    if (disabled) {
      atc.setAttribute('disabled', 'disabled');
      atc.classList.add('is-disabled');
    } else {
      atc.removeAttribute('disabled');
      atc.classList.remove('is-disabled');
    }
  }

  function setAtcLabel(text) {
    disableAtc(text, false);
  }

  function setAtcSoldOut() {
    disableAtc('Sold Out', true);
  }

  function setPreorderState(variant) {
    var publish = parseDate(variant.metafields && variant.metafields.publish_date);
    if (!publish) return false;
    var today = new Date();
    var ninetyDay = addDays(publish, -91);
    var requiresShipping = !!variant.requires_shipping;

    if (variant.available) {
      if (today < ninetyDay && requiresShipping) {
        disableAtc('Pre-Order: ' + formatDateMDY(ninetyDay), true);
        return true;
      }
      if (today < publish && !requiresShipping) {
        disableAtc('Available on ' + formatDateMDY(publish), true);
        return true;
      }
      if (today >= ninetyDay && today < publish && requiresShipping) {
        disableAtc('Pre-Order', false);
        return true;
      }
      return false;
    }
    if (today < ninetyDay && requiresShipping) {
      disableAtc('Pre-Order: ' + formatDateMDY(ninetyDay), true);
      return true;
    }
    if (today < publish && !requiresShipping) {
      disableAtc('Available on ' + formatDateMDY(publish), true);
      return true;
    }
    setAtcSoldOut();
    return true;
  }

  function setQuickViewVariant(variantId, opts) {
    opts = opts || {};
    var product = state.product;
    var view = state.productView;
    if (!product) return;
    var variant = product.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;

    var viewVariant = getViewVariant(view, variant.id);
    var mergedVariant = Object.assign({}, variant, {
      metafields: getMergedMetafields(product, viewVariant),
      requires_shipping:
        viewVariant && typeof viewVariant.requires_shipping === 'boolean'
          ? viewVariant.requires_shipping
          : variant.requires_shipping,
    });

    state.currentVariant = mergedVariant;

    var imgEl = contentEl.querySelector('[data-qv-image]');
    if (imgEl) {
      var nextSrc = variantFeaturedImage(product, variant);
      if (nextSrc) imgEl.setAttribute('src', nextSrc);
    }

    var badgeEl = contentEl.querySelector('[data-qv-badge]');
    if (badgeEl) {
      badgeEl.innerHTML = buildQuickviewBadge(product, view, mergedVariant);
    }
    var titleEl = contentEl.querySelector('[data-qv-title]');
    if (titleEl) {
      titleEl.textContent = getVariantTitle(product, view, variant);
    }

    var subtitleEl = contentEl.querySelector('[data-qv-subtitle]');
    if (subtitleEl) {
      var subtitle = getVariantSubtitle(view, variant);
      subtitleEl.textContent = subtitle;
      if (subtitle) {
        subtitleEl.classList.remove('hidden');
      } else {
        subtitleEl.classList.add('hidden');
      }
    }

    var seriesEl = contentEl.querySelector('[data-qv-series]');
    if (seriesEl) {
      var series = getSeries(view, variant);
      if (series) {
        seriesEl.textContent = 'Series: ' + series;
        seriesEl.classList.remove('hidden');
      } else {
        seriesEl.textContent = '';
        seriesEl.classList.add('hidden');
      }
    }

    var priceEl = contentEl.querySelector('[data-qv-price]');
    if (priceEl) {
      priceEl.innerHTML = priceMarkup(mergedVariant);
    }

    var detailsLink = contentEl.querySelector('[data-qv-details-link]');
    if (detailsLink) {
      detailsLink.setAttribute('href', product.url + '?variant=' + variant.id);
    }

    var options = getOptionList(product, view);
    options.forEach(function (opt) {
      var nameHandle = handleize(opt.name || '');
      var currentValue = variantOptionValue(variant, opt.position) || '';
      var currentEl = contentEl.querySelector('[data-qv-option-current="' + nameHandle + '"]');
      if (currentEl) currentEl.textContent = currentValue;
    });

    var optionButtons = contentEl.querySelectorAll('[data-option-value]');
    optionButtons.forEach(function (btn) {
      var pos = parseInt(btn.getAttribute('data-option-position'), 10);
      var val = btn.getAttribute('data-option-value');
      if (Number.isNaN(pos)) return;
      var current = variantOptionValue(variant, pos);
      var isSelected = current === val;
      if (btn.classList.contains('ais-quickview--swatch')) {
        btn.classList.toggle('selected', isSelected);
      } else {
        btn.classList.toggle('active', isSelected);
      }

      var unavailable = pos > 0 && !isValueReachable(product, mergedVariant, pos, val);
      btn.classList.toggle('is-unavailable', unavailable);
      if (btn.tagName === 'BUTTON') {
        if (unavailable) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
        }
      }
    });

    applyAtcState(mergedVariant);

    if (opts.initial) {
      var input = contentEl.querySelector('[data-qv-qty-input]');
      if (input) input.value = state.qty;
    }
  }

  function applyAtcState(variant) {
    var atc = contentEl.querySelector('[data-qv-atc]');
    var login = contentEl.querySelector('[data-qv-login]');
    var qty = contentEl.querySelector('[data-qv-qty]');
    if (!atc || !login) return;

    var isDigital = variantIsDigital(variant);
    if (isDigital && isGuest()) {
      atc.classList.add('hidden');
      if (qty) qty.classList.add('hidden');
      login.classList.remove('hidden');
      var variantUrl = state.product.url + '?variant=' + variant.id;
      login.setAttribute('href', buildLoginHref(variantUrl));
      return;
    }

    atc.classList.remove('hidden');
    if (qty) qty.classList.remove('hidden');
    login.classList.add('hidden');

    var handled = setPreorderState(variant);
    if (handled) return;

    if (!variant.available) {
      setAtcSoldOut();
      return;
    }
    setAtcLabel('Add to Cart');
  }

  function onAddToCartClick(e) {
    e.preventDefault();
    var atc = contentEl.querySelector('[data-qv-atc]');
    var atcText = contentEl.querySelector('[data-qv-atc-text]');
    if (!state.currentVariant || !atc || atc.hasAttribute('disabled')) return;
    var originalText = atcText.textContent;
    atc.setAttribute('disabled', 'disabled');
    atcText.textContent = 'Adding...';
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: state.currentVariant.id, quantity: state.qty || 1 }),
      signal: controller.signal
    })
      .then(function (r) {
        clearTimeout(timeoutId);
        if (!r.ok) {
          return r.json().then(data => {
            throw new Error(data.description || data.message || 'Add to Cart failed');
          }, () => {
            throw new Error('Add to Cart failed');
          });
        }
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cartUpdated', { detail: data }));
        close();
      })
      .catch(function (err) {
        atc.removeAttribute('disabled');
        atcText.textContent = originalText || 'Add to Cart';
        console.error('Add to cart error:', err);
        alert(err.message || 'Could not add item to cart. Please try again.');
      });
  }

  function loadProductIntoModal(args) {
    if (!args || !args.handle) return;

    var requestHandle = args.handle;
    var requestSeq = ++state.loadSeq;
    state.handle = requestHandle;
    state.qty = 1;
    state.product = null;
    state.productView = null;
    state.currentVariant = null;

    renderSkeleton();

    var handle = encodeURIComponent(requestHandle);
    var pJs = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Failed to load product');
      return r.json();
    });
    var pView = fetch('/products/' + handle + '?view=json', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to load product view');
        return r.json();
      })
      .catch(function () {
        return null;
      });

    Promise.all([pJs, pView])
      .then(function (results) {
        if (!state.open || state.loadSeq !== requestSeq || state.handle !== requestHandle) return;
        var product = results[0];
        var view = results[1];
        state.product = product;
        state.productView = view;

        var variant =
          (args.variantId &&
            product.variants.find(function (v) {
              return String(v.id) === String(args.variantId);
            })) ||
          product.variants.find(function (v) {
            return v.available;
          }) ||
          product.variants[0];

        state.currentVariant = variant;
        renderLayout();
      })
      .catch(function () {
        if (!contentEl || !state.open || state.loadSeq !== requestSeq) return;
        contentEl.innerHTML =
          '<div class="ais-quickview__error">' +
          'We could not load this product right now. ' +
          '<a href="/products/' +
          handle +
          '">View product details</a>.' +
          '</div>';
      });
  }

  function open(args) {
    if (!args || !args.handle) return;
    lastTrigger = document.activeElement;
    ensureModalRoot();
    state.open = true;
    state.handle = args.handle;
    state.qty = 1;
    state.animGen = (state.animGen || 0) + 1;
    rootEl.classList.remove('hidden');
    rootEl.classList.remove('is-closing');
    rootEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    document.addEventListener('keydown', onKeyDown);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (rootEl && state.open) {
          rootEl.classList.add('is-open');
          const closeBtn = rootEl.querySelector('.ais-quickview__close');
          if (closeBtn) closeBtn.focus();
        }
      });
    });
    loadProductIntoModal(args);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest('[data-quickview-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    open({
      handle: trigger.getAttribute('data-handle'),
      variantId: trigger.getAttribute('data-variant-id'),
      productId: trigger.getAttribute('data-product-id'),
    });
  });

  return {
    open: open,
    close: close,
  };
})();

if (typeof window !== 'undefined') {
  window.algoliaQuickView = algoliaQuickView;
}

/* A11y — SC 2.1.1. autocomplete-js puts role="combobox" on the .aa-Autocomplete
   wrapper, which is not focusable; ARIA 1.2 needs it on the input. aria-expanded
   stays on the wrapper as the source we mirror from — stripping it would make the
   next observer pass read it as absent and reset the input to false. */
document.addEventListener('algolia.hooks.initialize', function () {
  var STRIP = ['role', 'aria-haspopup'];

  function set(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function patch() {
    document.querySelectorAll('.aa-Autocomplete').forEach(function (root) {
      var input = root.querySelector('input.aa-Input');
      if (!input) return;
      var expanded = root.getAttribute('aria-expanded') === 'true';
      STRIP.forEach(function (attr) { root.removeAttribute(attr); });
      set(input, 'role', 'combobox');
      set(input, 'aria-expanded', expanded ? 'true' : 'false');
    });

    // Single tab stop. Covers both shapes: a link inside the option (our
    // product/collection templates) and the option element being the link
    // itself (default templates on sources like pages). Scoped to the listbox
    // so panel-level links such as no-results "Browse all products" stay
    // reachable. Down/Up plus aria-activedescendant are the navigation.
    document.querySelectorAll(
      '[role="listbox"] a[href], [role="listbox"] button, a[role="option"][href]'
    ).forEach(function (el) {
      if (el.tabIndex !== -1) el.tabIndex = -1;
    });
  }

  // childList covers the second root detached mode (<=680px) builds.
  new MutationObserver(patch).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'],
  });
  patch();
});
